import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import ArrowRight from '@mui/icons-material/ArrowRight';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';

const styles = {
  hovering: {
    outline: '2px dashed rgba(0,0,0,.5)',
    outlineOffset: '-2px',
  },
  dragging: {
    backgroundColor: 'rgba(0,0,0,.25)',
  },
  overlay: {
    position: 'absolute',
    display: 'inline-block',
    cursor: 'move',
  },
  arrowRight: {
    right: 0,
    top: 'calc(50% - 17.5px)',
    position: 'absolute',
  },
  arrowLeft: {
    left: 0,
    top: 'calc(50% - 17.5px)',
    position: 'absolute',
  },
  arrowUp: {
    left: 'calc(50% - 17.5px)',
    top: 0,
    position: 'absolute',
  },
  arrowDown: {
    left: 'calc(50% - 17.5px)',
    bottom: 0,
    position: 'absolute',
  },
};

class ImageOverlay extends React.PureComponent {
  nodeRef = React.createRef();

  state = {
    isHovering: false,
    isDragging: false,
  };

  componentDidUpdate = (_, prevState) => {
    if (prevState.isHovering !== this.state.isHovering || prevState.isDragging !== this.state.isDragging) {
      this.props.onInteractionChange(this.props.name, this.state.isHovering, this.state.isDragging);
    }
  };

  componentWillUnmount = () => {
    if (this.state.isHovering || this.state.isDragging) {
      this.props.onInteractionChange(this.props.name, false, false);
    }
  };

  handleDragStop = (e, data) => {
    this.setState({ isDragging: false, ...(e.type.startsWith('touch') && { isHovering: false }) });
    this.props.onDragEnd(data.x, data.y, this.props.name);
  };

  render() {
    return (
      <Draggable
        nodeRef={this.nodeRef}
        scale={this.props.scale}
        onStart={() => this.setState({ isDragging: true })}
        onStop={this.handleDragStop}
        position={{ x: this.props.x, y: this.props.y }}
      >
        <div
          ref={this.nodeRef}
          style={{
            ...styles.overlay,
            left: 0,
            top: 0,
            width: this.props.width,
            height: this.props.height,
            ...(this.state.isHovering && styles.hovering),
            ...(this.state.isDragging && styles.dragging),
          }}
          onMouseEnter={() => this.setState({ isHovering: true })}
          onMouseLeave={() => this.setState({ isHovering: false })}
          onMouseMove={() => this.setState({ isHovering: true })}
        >
          {(this.state.isHovering || this.state.isDragging) && (
            <>
              <ArrowRight
                color={this.state.isDragging ? 'primary' : 'secondary'}
                style={styles.arrowRight}
                fontSize="large"
              />
              <ArrowLeft
                color={this.state.isDragging ? 'primary' : 'secondary'}
                style={styles.arrowLeft}
                fontSize="large"
              />
              <ArrowDropUp
                color={this.state.isDragging ? 'primary' : 'secondary'}
                style={styles.arrowUp}
                fontSize="large"
              />
              <ArrowDropDown
                color={this.state.isDragging ? 'primary' : 'secondary'}
                style={styles.arrowDown}
                fontSize="large"
              />
            </>
          )}
        </div>
      </Draggable>
    );
  }
}

ImageOverlay.propTypes = {
  scale: PropTypes.number,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  onDragEnd: PropTypes.func,
  onInteractionChange: PropTypes.func,
  name: PropTypes.string,
};

ImageOverlay.defaultProps = {
  onDragEnd() {},
  onInteractionChange() {},
  scale: 1,
};

export default ImageOverlay;
